import { compose, withState, withHandlers, lifecycle } from "recompose";
import getCurrentUser from "../libs/getCurrentUser";
import { pathOr, path } from "ramda";

const getUser = path(["data", "user"]);
const getUserEmail = pathOr(null, ["data", "user", "email"]);
const getSource = res => pathOr([], ["data", "user", "sources"], res)[0] || {};
const getStoryImage = path(["storyImage", "uri"]);
const getWatermarkedStoryImage = path(["storyWithWatermarkImage", "uri"]);

const handleGetCurrentUser = ({ isUpdate, ...props }) => {
  return getCurrentUser().then(res => {
    if (res.errorMessage) {
      props.setError(res.errorMessage);
      return false;
    }
    props.setEmail(getUserEmail(res));
    //source
    const source = getSource(res);
    if (isUpdate && props.source === source) {
      return source.isFetching;
    }
    props.setIsFetching(source.isFetching);
    props.setSource(source);
    //story
    const storyUrl = source.withWatermark ? getWatermarkedStoryImage(source) : getStoryImage(source);
    props.addStory({
      storyUrl: getStoryImage(source),
      storyUrlWithWatermark: getWatermarkedStoryImage(source),
      customizationKey: props.defaultKey,
    });
    //payment
    if (source.paymentRequired) {
      if (window.gtag) {
        window.gtag("event", "begin_checkout", {
          user: getUser(res),
        });
      }
    }
    props.setCheckout(getUser(res) || {});
    if (!source.withWatermark && source.paymentRequired) {
      return false;
    }
    return source.isFetching;
  });
};

export const withUserFetch = compose(
  withState("email", "setEmail", null),
  withHandlers({
    fetchCurrentUser: props => () => {
      props.setError("");
      return handleGetCurrentUser(props);
    },
    updateCurrentUser: props => () => {
      props.setError("");
      return handleGetCurrentUser({ ...props, isUpdate: true });
    },
  }),
  withHandlers({
    refreshCurrentUser: props => () => {
      const interval = setInterval(() => {
        props.updateCurrentUser().then(isFetching => {
          if (!isFetching) {
            clearInterval(interval);
          }
        });
      }, 5000);
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchCurrentUser().then(shouldPoll => {
        if (shouldPoll) {
          this.props.refreshCurrentUser();
        }
      });
    },
  })
);
